import { API_GET_METHOD, API_POST_METHOD } from 'global_config/constant-global';
import HttpCodeMessage from 'shared_components/message_http_status';
import { axiosLabAPI } from 'services/axios';

export async function getModules(){

    let modules = [];
    try {
        const response = await axiosLabAPI({
            method: API_GET_METHOD,
            url: 'listofvalues/modules'
        });

        const { data } = response;

        if (data && data.STATUSCODE === 200 && data.RECORDS) {
            modules = data.RECORDS;
          }
    } catch (error) {
        HttpCodeMessage({ status: 500, message: error});
        return [];        
    }

    return modules;
}